export default "__VITE_ASSET__Ba7K0EWu__"